import React, { useEffect } from 'react'
import Offer from './Offer'
import { RootReducer } from 'src/redux/rootReducer'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom'
import { CLOSE_OFFER } from 'src/redux/listLayoutReducer'

const OfferModal = (): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { offerId, offerOpened } = useSelector((state: RootReducer) => state.listLayoutReducer)
  const navigationType = useNavigationType()

  useEffect(() => {
    if (navigationType === 'POP') {
      dispatch(CLOSE_OFFER())
    }
  }, [navigationType, dispatch])

  useEffect(() => {
    return () => {
      dispatch(CLOSE_OFFER())
    }
  }, [dispatch])

  useEffect(() => {
    if (offerOpened) {
      navigate(location.pathname, { replace: false })
      window.history.pushState({}, '', `/browsing/offer/${offerId ?? 0}`)
    }
  }, [offerOpened, dispatch, navigate, location.pathname, offerId])

  if (typeof offerId !== 'number' || !offerOpened) return <></>

  return (
    <div className="absolute top-0 left-0 bg-[white] min-h-screen max-h-screen w-full z-50 overflow-scroll">
      <Offer offerId={offerId} />
    </div>
  )
}

export default OfferModal
